<template>
  <div>
    <validation-observer ref="observer">
      <base-box title="高風險客戶之盡職調查問卷">
        <div class="form-box mt-default">

          <div class="form-box mt-default">
            <v-container grid-list-md
                        class="list-spacer">
              <v-layout row
                        wrap>
                <v-flex sm12
                        style="padding-left: 20px;">
                  <sub-title-qa>訪查方式
                  </sub-title-qa>
                  <validation-observer v-slot="{errors}">
                    <error-messages style="margin-top: 0px;"
                                    :value="errorsHandler(errors)">
                    </error-messages>
                    <sub-content-qa>
                      <v-layout align-center
                                wrap>
                        <validation-provider vid="visitCode_chk"
                                        name=" "
                                        rules="required"
                                        :immediate="(annexEdd.visitCode)?true:false">
                          <input :value="annexEdd.visitCode"
                              style="height:0;width:0"
                              id="visitCode_chk" />
                        </validation-provider>
                        <v-flex xs12
                                v-for="(item,index) in visitCodeList"
                                :key="index"
                                lg12
                                pl-0>
                          <v-layout align-center>
                            <v-checkbox v-model="annexEdd.visitCode"
                                        v-checker
                                        hide-details
                                        :label="item.codeName"
                                        :value="item.codeValue"
                                        class="shrink mr-2"></v-checkbox>

                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </sub-content-qa>
                  </validation-observer>
                </v-flex>

              </v-layout>
            </v-container>
          </div>

          <v-container grid-list-md>
            <v-layout row
                      wrap
                      ml-3
                      mt-5
                      class="form">
              <v-flex sm6>
                <sub-header><template v-slot:title>客戶姓名/身分證字號</template>
                </sub-header>
                <v-layout row
                          wrap>
                  <v-flex xs12>
                    <v-text-field :value="cusO.cusName + '/' + cusO.cusIdn" disabled outline/>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>

          <div class="form-box mt-default">
            <v-container grid-list-md
                        class="list-spacer">
              <v-layout row
                        wrap>
                <v-flex sm12
                        style="padding-left: 20px;">
                  <sub-title-qa>1.客戶之財富或主要收入來源為何﹖(請檢核與業務員報告書是否一致)
                  </sub-title-qa>
                  <validation-observer v-slot="{errors}">
                    <error-messages style="margin-top: 0px;"
                                    :value="errorsHandler(errors)">
                    </error-messages>
                    <sub-content-qa>
                      <v-layout align-center
                                wrap>
                        <validation-provider vid="incomeSource_chk"
                                        name=" "
                                        rules="required"
                                        :immediate="incomeSourceAry.length>0">
                            <input :value="incomeSourceAry.join('')"
                              style="height:0;width:0"
                              id="incomeSource_chk" />
                        </validation-provider>
                        <v-flex xs12
                                v-for="(item,index) in incomeSourceList"
                                :key="index"
                                lg12
                                pl-0>
                          <v-layout align-center>
                            <v-checkbox v-model="incomeSourceAry"
                                        v-checker
                                        hide-details
                                        :label="item.codeName"
                                        :value="item.codeValue"
                                        class="shrink mr-2"></v-checkbox>

                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </sub-content-qa>
                  </validation-observer>
                </v-flex>

                <v-flex sm12
                        style="padding-left: 30px;">
                        1-1.請具體說明客戶財富或主要收入來源為何?
                        <b-textarea
                            v-model="annexEdd.incomeSourceOther"
                            maxlength="30"
                            :rules="(needIncomeSourceOther)?'required':''"
                            vname="其他說明"
                            vid="incomeSourceOther"
                            :disabled="!needIncomeSourceOther"
                            outline></b-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </div>

          <div class="form-box mt-default">
            <v-container grid-list-md
                        class="list-spacer">
              <v-layout row
                        wrap>
                <v-flex sm12
                        style="padding-left: 20px;">
                  <sub-title-qa>2.預期保費支付方式? (請檢核與客戶提供之支付文件是否一致)
                  </sub-title-qa>
                  <validation-observer v-slot="{errors}">
                    <error-messages style="margin-top: 0px;"
                                    :value="errorsHandler(errors)">
                    </error-messages>
                    <sub-content-qa>
                      <v-layout align-center
                                wrap>
                        <validation-provider vid="payMode_chk"
                                        name=" "
                                        rules="required"
                                        :immediate="(annexEdd.payMode)?true:false">
                            <input :value="annexEdd.payMode"
                              style="height:0;width:0"
                              id="payMode_chk" />
                        </validation-provider>
                        <v-flex xs12
                                v-for="(item,index) in payModeList"
                                :key="index"
                                lg12
                                pl-0>
                          <v-layout align-center>
                            <v-checkbox v-model="annexEdd.payMode"
                                        v-checker
                                        hide-details
                                        :label="item.codeName"
                                        :value="item.codeValue"
                                        class="shrink mr-2"></v-checkbox>

                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </sub-content-qa>
                  </validation-observer>
                </v-flex>

                <v-flex sm12
                        style="padding-left: 30px;">
                        2-1.請具體說明預期保費支付方式?
                        <b-textarea
                            v-model="annexEdd.payModeOther"
                            maxlength="30"
                            :rules="(needPayModeOther)?'required':''"
                            vname="其他說明"
                            vid="payMode"
                            :disabled="!needPayModeOther"
                            outline></b-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </div>

        </div>
      </base-box>


    </validation-observer>
  </div>
</template>
<script>
import { withDebounce } from '@/utils'
import { halfFull, policyChangedChecker } from '@/mixin'
import { createNamespacedHelpers } from 'vuex'
const { mapActions } = createNamespacedHelpers('ins')

export default {
  name: 'high-risk',
  mixins: [halfFull, policyChangedChecker],

  props: {
    transCode: String,
    annexCode: String,
    annexVersion: String,
    propAnnexEdd: Object,
    cusO: Object
  },

  data () {
    return {
      annexEdd: {
        transCode: '', //要保書序號(行動投保序號)
        annexCode: '', // 附件代碼
        annexVersion: '', // 附件版本
        status: '', // 填寫狀態(T:暫存; S:完成)
        incomeSource: '',  //客戶之財富或主要收入來源
        incomeSourceOther: '', //請具體說明客戶財富或主要收入來源
        payMode: '', //預期保費支付方式
        payModeOther: '', //請具體說明預期保費支付方式
        visitCode: '', //查訪方式
        verifyName: '' //審核主管姓名
      },
      visitCodeList: [],
      incomeSourceList: [],
      incomeSourceAry: [],

      needIncomeSourceOther: false,
      needPayModeOther: false
    }
  },

  created () {
    this.visitCodeList = this.$store.getters['common/admCodeDetail']({
      codeType: 'VISIT_CODE',
      toObject: false
    })
    this.incomeSourceList = this.$store.getters['common/admCodeDetail']({
      codeType: 'INCOME_SOURCE',
      toObject: false
    })
    this.payModeList = this.$store.getters['common/admCodeDetail']({
      codeType: 'PAY_MODE',
      toObject: false
    })


    this.annexEdd = {...this.propAnnexEdd}

    if (this.annexEdd.incomeSource) {
      let ary = this.annexEdd.incomeSource.split(',')
      ary.forEach(e => {
        for (let i = 0; i < this.incomeSourceList.length; i++) {
          if (this.incomeSourceList[i].codeValue === e) {
            this.incomeSourceAry[i + 1] = e

            if (e === '6') {
              this.needIncomeSourceOther = true
            }
          }
        }
      })
    }
    if (!this.needIncomeSourceOther) {
      this.annexEdd.incomeSourceOther = ''
    }

    if (this.annexEdd.payMode === '7') {
      this.needPayModeOther = true
    } else {
      this.needPayModeOther = false
      this.annexEdd.payModeOther = ''
    }


    this.$nextTick(() => {
      setTimeout(() => {
        this.$doValidate('observer')
      }, 0)
    })
  },

  watch: {
    'incomeSourceAry': {
      immediate: false,
      handler (newVal, oldVal) {
        if (newVal && newVal.length > 0) {
          this.needIncomeSourceOther = false
          newVal.forEach(e => {
            if (e === '6') {
              this.needIncomeSourceOther = true
            }
          })
        }
        if (!this.needIncomeSourceOther) {
          this.annexEdd.incomeSourceOther = ''
        }
      }
    },
    'annexEdd.payMode': {
      immediate: false,
      handler (newVal, oldVal) {
        if (newVal === '7') {
          this.needPayModeOther = true
        } else {
          this.needPayModeOther = false
          this.annexEdd.payModeOther = ''
        }
      }
    },
    changedFlag (v) {
      if (v) {
        this.$emit('setTabDone', false)
      }
    }

  },

  methods: {
    ...mapActions([
      'saveInsPoliciesAnnexEdd'
    ]),
    errorsHandler (errors) {
      const errorsArray = this.$errorMsgHandler(errors)

      return errorsArray
    },
    doValidate () {
      this.$doValidate('observer')
    },
    done: withDebounce(function () {
      return this.$doValidate('observer').then(isValid => {
        if (isValid) {
          this.annexEdd.status = 'S'
          this.annexEdd.transCode = this.transCode
          this.annexEdd.annexCode = this.annexCode
          this.annexEdd.annexVersion = this.annexVersion
          this.annexEdd.cusCode = this.cusO.cusCode

          this.annexEdd.incomeSource = this.incomeSourceAry.filter(item => (item)).join(',')

          this.saveInsPoliciesAnnexEdd(this.annexEdd).then(() => {
            this.$alert('儲存成功', yn => {
              this.$emit('toNextTab')
            })
            this.$changedReset()
            this.$emit('setTabDone', true)
            this.$emit('goTop')

          })
        }
      })
    }),
    tempSave: withDebounce(function () {
      this.annexEdd.status = 'T'
      this.annexEdd.transCode = this.transCode
      this.annexEdd.annexCode = this.annexCode
      this.annexEdd.annexVersion = this.annexVersion
      this.annexEdd.cusCode = this.cusO.cusCode

      this.annexEdd.incomeSource = this.incomeSourceAry.filter(item => (item)).join(',')

      this.saveInsPoliciesAnnexEdd(this.annexEdd).then(() => {
        this.$alert('暫存成功')
      })
    }),
    cleanAll () {
      this.annexEdd = { ...this.$options.data().annexEdd }

      this.incomeSourceAry = []

      this.$reset('observer')
      this.$emit('setTabDone', false)
    }
  }
}
</script>
